
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"

@Component
export default class Message extends Vue {
  @Prop()
  message: string | null

  @Prop({default: true})
  error: boolean

  @Prop({default: false})
  noMarginTop: boolean

  get containerClass(): string {
    return `q-pa-xs ${this.noMarginTop ? "" : "q-mt-sm "}${
      this.error ? "bg-red-1" : "bg-green-1"
    }`
  }

  get textClass(): string {
    return `text-caption -text-size-8 text-weight-medium ${
      this.error ? "-error" : "-success"
    }`
  }
}
